import React, { Component } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import NeedHelp from '../Elements/NeedHelp';
import { getInitialRoute } from '../../../../../../utils'
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import InputField from '../Elements/InputField';
import CheckBoxField from '../Elements/CheckboxField';

class Giphy extends Component {

    constructor(props){
        super(props);
        this.state={
            loading:false,
            isChecked:false,
            fieldOne:'',
            fieldTwo:'',
            fieldThree:'',
            tabOneError:false,
            tabTwoError:false,
            tabThreerror:false,
            filterType:"search"
        }
    }

  submit = () =>{
    const {fieldOne,fieldTwo,fieldThree,filterType} = this.state;
    if((fieldOne!='' && filterType=="search")||(fieldTwo!='' && filterType=="search sticker")||(fieldThree!='' && filterType =="handle")){
        this.setState({loading:true});
        const { hideAddfeed,navigation,wallId,networkId } = this.props;
        const postBody = this.cookPostBody();

        createFeedAction(postBody,networkId,(feedId)=>this.setState({loading:false},()=>{ 
            if(feedId){
                navigation(`/moderation/index/${wallId}`);
                hideAddfeed();
            }  
        }));

    }else{
        if (filterType == "search") {
            this.setState({tabOneError:true});
        } else if (filterType == "search sticker"){
            this.setState({tabTwoError:true});
        }else {
            this.setState({tabThreerror:true});
        }
    }
  }

  cookPostBody = () => {
    const { wallId, networkId } = this.props;
    const { isChecked,fieldOne,fieldTwo,fieldThree,filterType } = this.state;
    return {
        wallId: wallId,
        networkId: networkId,
        filter: this.getFilterType(),
        field:filterType == "search" ? fieldOne : filterType == "search sticker" ? fieldTwo : filterType == "handle" ? fieldThree : '',
        connetedAccount: 0,
        feedType: 2,
        account: "",
        hashtagIGTV: 0,
        onlyReels: 0,
        moderation: isChecked ? 1 : 0
    }
}

getFilterType = () => {
    return this.props.feedInfo[0].networkTab.reduce((acc, curr) => {
        if ((curr.feedtype).toLowerCase()===(this.state.filterType).toLowerCase()) {
            return curr.filter;
        }
        return acc;
    }, this.props.feedInfo[0].networkTab[0].filter)
}

  handleOnChange=(e)=>{
    this.setState({[e.target.name]: e.target.value, tabOneError: false, tabTwoError: false, tabThreerror: false });
  }

  componentDidMount(){
    this.props.onFilterNameChange(this.state.filterType);
}

  render() {
    const { onBack, onFilterNameChange, } = this.props;
    const {loading,isChecked,fieldOne,fieldTwo,fieldThree,tabOneError,tabTwoError,tabThreerror} = this.state;
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-body">
                    <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details createFeedInsta personalizePopup create_feed_wt">
                        <Tabs defaultActiveKey="search" id="CreateFeedTab" className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => { this.setState({ filterType: e },()=>onFilterNameChange(e))}}>
                            <Tab eventKey="search" className="nav-link p-0 ms-0 mt-2" title={<span>Search(#)</span>}>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="fas fa-star"></i>
                                            </span>
                                        </div>
                                    <InputField autoComplete={true} name={"fieldOne"} value={fieldOne} className={`mycheck form-control`} placeholder="Search giphy keyword to fetch feed"  onChangeHandler={(e) => this.handleOnChange(e)} />
                                    </div>
                                   {tabOneError &&  <span id="feedsgiphy_searcherror" className="errorMessage required">This field is required.</span>}
                                </div>
                                <div className="form-group hideforBSearch">
                                    <div className="checkbox-inline mb-2">
                                        <CheckBoxField isChecked={isChecked} onChangeHandler={(e) => this.setState({isChecked:e.target.checked})} name={"moderation"} id="checkbox_one" />
                                    </div>
                                </div>
                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                                        {getInitialRoute() === 'widget' ? 
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/510156339'} supportLink={''} />
                                        :
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/510156339'} supportLink={''} />
                                        }
                                        <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} />
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="search sticker" className="nav-link p-0 ms-0 mt-2" title={<span>Search Sticker(#)</span>}>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="fas fa-star"></i>
                                            </span>
                                        </div>
                                    <InputField autoComplete={true} name={"fieldTwo"} value={fieldTwo} className={`mycheck form-control`} placeholder="Search giphy keyword to fetch feed"  onChangeHandler={(e) => this.handleOnChange(e)} />
                                    </div>
                                   {tabTwoError &&  <span id="feedsgiphy_searcherror" className="errorMessage required">This field is required.</span>}
                                </div>
                                <div className="form-group hideforBSearch">
                                    <div className="checkbox-inline mb-2">
                                    <CheckBoxField isChecked={isChecked} onChangeHandler={(e) => this.setState({isChecked:e.target.checked})} name={"moderation"} id="checkbox_two" />
                                    </div>
                                </div>
                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                                        {getInitialRoute() === 'widget' ? 
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/510156339'} supportLink={''} />
                                        :
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/510156339'} supportLink={''} />
                                        }
                                        <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} />
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="handle" className="nav-link p-0 ms-0 mt-2" title={<span>Handle(@)</span>}>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">
                                                <i className="fas fa-at"></i>
                                            </span>
                                        </div>
                                    <InputField autoComplete={true} name={"fieldThree"} value={fieldThree} className={`autosearch form-control`} placeholder="Enter user handle"  onChangeHandler={(e) => this.handleOnChange(e)} />
                                    </div>
                                    {tabThreerror && <span id="feedsfield1error" className="errorMessage required">This field is required</span>}
                                </div>
                                <div className="form-group hideforBSearch">
                                    <div className="checkbox-inline mb-2">
                                    <CheckBoxField isChecked={isChecked} onChangeHandler={(e) => this.setState({isChecked:e.target.checked})} name={"moderation"} id="checkbox_three" />
                                    </div>
                                </div>
                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">{getInitialRoute() === 'widget' ? 
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/510156339'} supportLink={''} />
                                        :
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/510156339'} supportLink={''} />
                                        }
                                        <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} />
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    )
  }
}

export default Giphy;
